
require(["jquery"], function($) {
	$.fn.accessibleDropDown = function() {
        var el = $(this);
        /* Make dropdown menus keyboard accessible */
        $("a", el).on('focus', function() {
            if ($(this).parent().hasClass('has-dropdown')) {
                $(this).parent().find('.dropdown').addClass('hover');
            } else if (($(this).parent().parent().hasClass('dropdown') === false)) {
                $(document).find('.dropdown').removeClass('hover');
            }
        }).on('keydown', function(e) {
            //if tab is pressed but not shift
            if (e.keyCode == 9 && !e.shiftKey) {
                //and element is the last child in menu
                if ($(this).parent().is(':last-child')) {
                    $(this).parent().parent().removeClass('hover');
                }
            }
        });
        $(document).foundation();
	}

    $.fn.accessibleDropDownClear = function() {
        $("a", $(this)).off('focus').off('keydown');
    }

    $(document).click(function() {
        //if someone uses keyboard and switches to mouse close menu if mouse click isn't focused on a navigation element
        if ($('nav a').is(':focus') === false) {
            $('.dropdown').removeClass('hover');
        }
    });
});